import Header from "@components/Header";
import PageBody from "@components/PageBody";
import Footer from "@components/Footer";

function Account() {
  return (
    <>
      <Header />
      <PageBody column></PageBody>
      <Footer />
    </>
  );
}

export default Account;
